import React, { FC } from 'react';
import { Label, Tooltip, Placement } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// own components
import CommonIcon from 'components/CommonIcon';

const Div = styled.div`
  margin: 1em 0;
`;

const StyledLabel = styled(Label)`
  margin-right: 0.25em;
`;

interface Props {
  iconName?: string;
  title?: string;
  titlePosition?: Placement;
  children?: string;
}

const RichLabel: FC<Props> = ({ iconName, title, titlePosition = 'right', children }) => (
  <Div>
    <StyledLabel>{children}</StyledLabel>
    {title ? (
      <Tooltip placement={titlePosition} content={title}>
        {iconName && <CommonIcon name={iconName} isLabelIcon />}
      </Tooltip>
    ) : (
      iconName && <CommonIcon name={iconName} isLabelIcon />
    )}
  </Div>
);

export default RichLabel;
